<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/manage-courses" color="error" exact icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 secondary--text headline">{{courseData.name}}, {{courseData.onlineDays + ' days online'}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="text-xs-center" xs12 md10 lg9>
      <v-tabs class="pa-0 ma-0" v-model="activeTab" color="transparent" slider-color="accent" centered>
        <v-tab ripple>Students</v-tab>
        <v-tab ripple>Edit</v-tab>
        <v-tab-item>
          <r-student-list></r-student-list>
        </v-tab-item>
        <v-tab-item>
          <r-edit-course></r-edit-course>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import EditCourse from './EditCourse.vue'
import StudentList from './StudentList.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rEditCourse: EditCourse,
    rStudentList: StudentList
  },
  data: () => ({
    activeTab: null,
    courseData: {}
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.courseData = this.$store.getters.courseByKey(this.$route.params.courseKey)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/ManageCourse.vue